module.exports = __webpack_public_path__ + "cornerSprite-2227d1c3c102dd9a510aca03ea71ed0e.png";